export default {
  assetsPath: `${process.env.VUE_APP_SITE}/api/wp-content/uploads/`,
  apiPath: `${process.env.VUE_APP_SITE}/api/wp-admin/admin-ajax.php`
}
